import React, { useState } from 'react'
import { Panel, Message } from 'rsuite'
import { useForm, Controller } from 'react-hook-form'
import ButtonPanelWidget from '../../ButtonPanelWidget'
import { startLoading, doneLoading } from '../../../utils/loading'
import {
  downloadExtentionTimePerPeriodReport,
  searchExtentionTimePerPeriodPage,
} from '../../../redux/actions/contractExtendTimeReport'
import { downloadFile } from '../../../utils/fileUtil'
import OverlayLoader from '../../../components/OverlayLoader/OverlayLoader'
import ExtentionTimePerPeriodReportForm from './ExtentionTimePerPeriodReportForm'
import ExtentionTimePerPeriodReportTable from './ExtentionTimePerPeriodReportTable'

export default function ExtentionTimePerPeriodReportWidget(props) {
  const [isError, setIsError] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const { register, handleSubmit, errors, control, getValues, setValue, clearErrors } = useForm()
  const [formSchema] = useState(props.schema)
  const [dataTable, setDataTable] = useState()
  const [errorMsg, setErrorMsg] = useState()
  const [condition, setCondition] = useState({})
  const [pagSize, setPagSize] = useState(25)
  const [clearValue, setClearValue] = useState(false)

  const buildRequest = (data, pageNumber = 1, pageSize = pagSize) => ({
    pageNumber,
    pageSize,
    budgetYearFrom: data.budgetYearFrom ? Number(data.budgetYearFrom) : null,
    budgetYearTo: data.budgetYearTo ? Number(data.budgetYearTo) : null,
    contrectNo: data.contrectNo || null,
    projectCode: data.projectCode || null,
    projectName: data.projectName || null,
    department: data.department || null,
  })

  const onSubmit = (data) => {
    setCondition(data)
    handlePreviewReport(buildRequest(data, 1, pagSize))
  }

  const handleSubmitOnPrint = (data) => {
    setCondition(data)
    handleDownloadReport(buildRequest(data))
  }

  const handelGetSchemaOnReload = (pagesize, pagenumber) => {
    setPagSize(pagesize)
    handlePreviewReport(buildRequest(condition, pagenumber, pagesize))
  }

  const handleCancel = () => {
    setValueNullField()
    setDataTable(null)
  }

  const handlePreviewReport = async (request) => {
    setIsLoading(true)
    startLoading()
    setIsError(false)
    try {
      const response = await searchExtentionTimePerPeriodPage(request)
      if (response) {
        setDataTable(response)
      } else {
        handelSetErrorMsg('error', 'ไม่สามารถแสดงข้อมูลได้')
      }
    } catch (e) {
      setIsError(true)
      handelSetErrorMsg('error', e?.response?.data?.errors?.message || 'ไม่สามารถแสดงข้อมูลได้')
    }
    setIsLoading(false)
    doneLoading()
  }

  const handleDownloadReport = async (request) => {
    setIsLoading(true)
    startLoading()
    setIsError(false)
    try {
      const file = await downloadExtentionTimePerPeriodReport(request)
      if (file) {
        const fileName = `${formSchema?.header?.header || 'report'}.xlsx`
        console.log('fileName ', fileName)
        downloadFile(file, fileName)
      } else {
        handelSetErrorMsg('error')
      }
    } catch (e) {
      console.log('error ', e)
    }
    setIsLoading(false)
    doneLoading()
  }

  const handelSetErrorMsg = (type, description) => {
    const desc = description || 'ไม่สามารถทำรายการได้ กรุณาลองใหม่หรือติดต่อผู้ดูแลระบบ'
    setErrorMsg({ type, description: desc })
    setTimeout(() => setErrorMsg(null), 5000)
  }

  const setValueNullField = () => {
    for (const key in getValues()) {
      setValue(key, null)
    }
    setClearValue(true)
    setTimeout(() => setClearValue(false), 500)
    clearErrors()
  }

  return (
    <>
      <Panel shaded header={formSchema?.header?.header} collapsible defaultExpanded>
        <ExtentionTimePerPeriodReportForm
          schema={formSchema?.searchForm}
          register={register}
          Controller={Controller}
          control={control}
          clearValue={clearValue}
        />

        <hr />

        {errorMsg && (
          <Message
            showIcon
            type={errorMsg.type}
            description={errorMsg.description}
            style={{ marginBottom: 20 }}
          />
        )}

        <ButtonPanelWidget
          isEdit={true}
          isError={isError}
          buttonText={formSchema?.searchForm?.buttonText || ''}
          onPreview={handleSubmit(onSubmit)}
          onPrint={handleSubmit(handleSubmitOnPrint)}
          onCancel={handleSubmit(handleCancel)}
        />
      </Panel>

      {isLoading && !isError && <OverlayLoader />}

      {dataTable && (
        <>
          <ExtentionTimePerPeriodReportTable
            schema={dataTable}
            Controller={Controller}
            control={control}
            pagination={true}
            loading={isLoading}
            onReload={handelGetSchemaOnReload}
          />
          <br />
        </>
      )}
    </>
  )
}
